import { useMemo } from 'react';
import { path } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';

import fetch from 'features/common/fetch';

export const useIgnoreErrorsWhen = ({ fetchStorePath, attributePath, value, condition }) => {
	const fetchState = useSelector(fetch.selectors.getFetchState(fetchStorePath));

	return useMemo(() => {
		if (fetchState?.error) {
			const errAttribute = path(attributePath, fetchState);

			if (!isNilOrEmpty(value)) {
				return errAttribute === value;
			}

			if (condition) {
				return condition(errAttribute);
			}
		} else {
			return false;
		}
	}, [fetchState, attributePath, value, condition]);
};
